import React, { useState, useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';

import BasicLayout from './BasicLayot';
import ErrorBoundary from './ErrorBoundary';

import ItemsPage from './Items/MainPage';
import SingleItemPage from './Items/SingleItemPage/MainPage';
import SingleVariantPage from './Items/SingleVariantPage/MainPage';
import SingleMonoboxPage from './Items/SingleMonoboxPage/MainPage';

import PhysicalSetsJournal from './Items/PhysicalSetsPage/PhysicalSetsJournal';
import SinglePhysicalSetOrder from './Items/PhysicalSetsPage/SinglePhysicalSetOrder';
import SinglePhysicalSet from './Items/PhysicalSetsPage/SinglePhysicalSet';

import CollectionsPage from './Items/CollectionsPage/';
import SingleCollectionPage from './Items/CollectionsPage/SingleCollection';
import CatalogTuningPage from './Items/CollectionsPage/CatalogTuning';

import PricesPage from './Items/PricesPage';

import ReviewsPage from './Items/ReviewsPage';

import ImportsPage from './Imports';
import XlsImportPage from './Imports/SingleImport';

import OrdersPage from './Orders/MainPage';
import SingleOrderPage from './Orders/SingleOrderPage/MainPage';
import ShippingsPage from './Orders/ShippingsPage';
import SubscriptionsPage from './Orders/SubscriptionsPage';

import OrdersExportPage from './Orders/ExportPage';
import NewOrdersExportPage from './Orders/ExportPage/SingleExportPage';
import OrdersExportReportPage from './Orders/ExportPage/ExportReportPage';

import OrdersImportPage from './Orders/ImportPage';
import OrdersSingleImportPage from './Orders/SingleImportPage';

import SuppliesPage from './Supplies/MainPage';
import SingleSuppliePage from './Supplies/SingleSuppliePage/MainPage';

import SummaryPage from './Summary';

import FinancePage from './Finance/FinancesPage';
import PricingPlansPage from './Finance/PricingPlansPage';
import BillPage from './Finance/SingleBillPage';

import SettingsPage from './Settings';

import ImportsReportPage from './Imports/ImportsReportPage';

import ModalWrapper from './Modal';

import SpinnerBlock from './common/SpinnerBlock';

import { setPreloadingState } from '../actions/app';
import { fetchGetAccountInfo, logout } from '../actions/auth';
import { fetchGetDeliveryInfo, fetchGetWarehouses, fetchGetOrders } from '../actions/orders';
import {
  fetchGetCheckoutSettings,
  fetchGetOrganizationSettings,
  fetchGetCountriesList,
  fetchGetPriceSettings,
  fetchGetPaymentSettings,
} from '../actions/settings';

import { getPreloadPromise, getBasicRedirectRoute } from '../helpers/privileges';
import SuppliesExportPage from './Supplies/ExportPage';
import NewSuppliesExportPage from './Supplies/ExportPage/SingleExportPage';
import AdminPage from './Admin';
import ChestnyZnakImport from './Imports/ChestnyZnakImport';
import DocumentsPage from './Documents';

const PrivateRouter = (props) => {
  const { auth, match, setPreloadingState } = props;

  const { account } = auth;

  const history = useHistory();
  const preloadingIsDone = useSelector((state) => state.app.preloadingIsDone);
  const [customHeader, setCustomHeader] = useState(null);
  const [mobileCustomMenu, setMobileCustomMenu] = useState(null);
  const [basicRedirect, setBasicRedirect] = useState(null);
  const admin = localStorage.getItem('admin');
  const adminPanel = localStorage.getItem('adminPanel');

  useEffect(() => {
    (async function () {
      if (!preloadingIsDone) {
        const result = await getPreloadPromise(auth.privileges, props);
        if (history.location.pathname === '/start') {
          //TODO mb remove ???
          const basicRedirectRoute = getBasicRedirectRoute(
            auth.privileges,
            result[result.length - 1],
          );
          if (basicRedirectRoute) {
            setBasicRedirect(`/${basicRedirectRoute}`);
          }
        }
        setPreloadingState(true);
      }
    })();
  }, []);

  useEffect(() => {
    if (preloadingIsDone && basicRedirect) {
      history.push(basicRedirect);
      setBasicRedirect(null);
    }
  }, [preloadingIsDone, basicRedirect]);

  if (!preloadingIsDone) return null;
  return (
    <>
      <BasicLayout
        auth={auth}
        match={match}
        logout={logout}
        customHeader={customHeader}
        mobileCustomMenu={mobileCustomMenu}
      >
        <ErrorBoundary>
          <Route exact path="/summary" render={(props) => <SummaryPage {...props} />} />
          <Route
            exact
            path="/items"
            render={(props) => <ItemsPage {...props} setMobileCustomMenu={setMobileCustomMenu} />}
          />
          <Route
            exact
            path="/items/:id"
            render={(props) => <SingleItemPage {...props} setCustomHeader={setCustomHeader} />}
          />
          <Route
            exact
            path="/items/:id/variants/:vid"
            render={(props) => <SingleVariantPage {...props} setCustomHeader={setCustomHeader} />}
          />
          <Route
            exact
            path="/items/:id/monoboxes/:vid"
            render={(props) => <SingleMonoboxPage {...props} setCustomHeader={setCustomHeader} />}
          />
          <Route exact path="/physical-sets-journal" component={PhysicalSetsJournal} />
          <Route exact path="/physical-set-order" component={SinglePhysicalSetOrder} />
          <Route exact path="/physical-set" component={SinglePhysicalSet} />
          <Route exact path="/collections" component={CollectionsPage} />
          <Route
            exact
            path="/collections/:id"
            render={(props) => (
              <SingleCollectionPage {...props} setCustomHeader={setCustomHeader} />
            )}
          />
          <Route exact path="/catalog-tuning" component={CatalogTuningPage} />
          {/* <Route exact path="/prices" component={UnderConstructionPage} /> */}
          <Route exact path="/reviews" component={ReviewsPage} />
          <Route exact path="/imports" component={ImportsPage} />
          <Route exact path="/imports-products/new" component={XlsImportPage} />
          <Route exact path="/imports/:id" component={ImportsReportPage} />
          <Route exact path="/imports-chz/new" component={ChestnyZnakImport} />

          <Route
            exact
            path="/orders"
            render={(props) => <OrdersPage {...props} setMobileCustomMenu={setMobileCustomMenu} />}
          />
          <Route
            exact
            path="/orders/:id"
            render={(props) => (
              <SingleOrderPage {...props} setMobileCustomMenu={setMobileCustomMenu} />
            )}
          />
          <Route
            exact
            path="/subscriptions"
            render={(props) => (
              <SubscriptionsPage {...props} setMobileCustomMenu={setMobileCustomMenu} />
            )}
          />
          <Route exact path="/orders-export" component={OrdersExportPage} />
          <Route exact path="/orders-export/new" component={NewOrdersExportPage} />
          <Route exact path="/orders-export/report/:id" component={OrdersExportReportPage} />
          <Route exact path="/orders-import" component={OrdersImportPage} />
          <Route exact path="/orders-import/new" component={OrdersSingleImportPage} />
          <Route exact path="/shippings" component={ShippingsPage} />
          <Route exact path="/supplies" component={SuppliesPage} />
          {account.displayFinance && (
            <>
              <Route exact path="/finances" component={FinancePage} />
              <Route exact path="/pricing-plans" component={PricingPlansPage} />
              <Route exact path="/finances/:id" component={BillPage} />
            </>
          )}
          <Route
            exact
            path="/supplies/:id"
            render={(props) => <SingleSuppliePage {...props} setCustomHeader={setCustomHeader} />}
          />
          <Route exact path="/supplies/export" component={SuppliesExportPage} />
          <Route exact path="/supplies/export/new" component={NewSuppliesExportPage} />
          <Route exact path="/supplies/export/report/:id" component={OrdersExportReportPage} />
          <Route
            exact
            path="/settings"
            render={(props) => <SettingsPage {...props} setCustomHeader={setCustomHeader} />}
          />
          <Route
            exact
            path="/documents"
            render={(props) => <DocumentsPage {...props} setCustomHeader={setCustomHeader} />}
          />
          {admin && adminPanel && (
            <Route
              exact
              path="/admin"
              render={(props) => <AdminPage {...props} setCustomHeader={setCustomHeader} />}
            />
          )}
          <Route exact path="/start" render={() => <SpinnerBlock show />} />
        </ErrorBoundary>
      </BasicLayout>
      <ModalWrapper />
    </>
  );
};

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = {
  setPreloadingState,
  fetchGetAccountInfo,
  fetchGetDeliveryInfo,
  fetchGetWarehouses,
  fetchGetCheckoutSettings,
  fetchGetOrganizationSettings,
  fetchGetCountriesList,
  fetchGetOrders,
  fetchGetPriceSettings,
  fetchGetPaymentSettings,
  logout,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRouter);
